import keys from './languages/keys';

const TKeys = keys;
export default TKeys;
